import { Injectable } from '@angular/core';

import { LabelConfigMultiAssignEffects } from '../../../effects/label-config-multi-assign.effects';
import { LabelConfigMultiAssignState } from '../../../state/label-config-multi-assign.state';

/**
 * Coordination surface of ONE multi-assign dialog session, consumed by
 * `LabelConfigEditorComponent`. Pure passthrough by design: the form lives in
 * the session state and the two real behaviours (load, submit) live in the
 * session effects, so this tier only picks what the view is allowed to see.
 */
@Injectable()
export class LabelConfigMultiAssignFacade {
  constructor(
    private readonly effects: LabelConfigMultiAssignEffects,
    private readonly state: LabelConfigMultiAssignState
  ) {}

  // ============================================================================
  // Selectors — State passthrough
  // ============================================================================

  public readonly rows$ = this.state.checklistRows$;
  public readonly loading$ = this.state.loading$;
  public readonly error$ = this.state.error$;
  public readonly isEmpty$ = this.state.isEmpty$;
  public readonly color$ = this.state.color$;
  public readonly alpha$ = this.state.alpha$;
  public readonly pickedColor$ = this.state.pickedColor$;
  public readonly applyToCountParams$ = this.state.applyToCountParams$;
  public readonly allChecked$ = this.state.allChecked$;
  public readonly someChecked$ = this.state.someChecked$;
  public readonly canSubmit$ = this.state.canSubmit$;

  /** One-shot session outcome the dialog host closes on. */
  public readonly outcome$ = this.effects.outcome$;

  // ============================================================================
  // Effects / updaters — passthrough
  // ============================================================================

  public readonly initialize = this.effects.loadUsage;
  public readonly submit = this.effects.submit;
  public readonly dismiss = this.effects.dismiss;
  public readonly toggleRow = this.state.toggleRow;
  public readonly toggleAll = this.state.toggleAll;
  public readonly setColor = this.state.setColor;
  public readonly setAlpha = this.state.setAlpha;
}
